import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Dropdown, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../context/Theme';
import { UserContext } from '../context/User';
import { StatusContext } from '../context/Status';
import { API, getLogo, showSuccess } from '../helpers';
import { getPageTitleKey } from './nav-items';
import './Topbar.css';

const LANGS = [
  { key: 'tr', text: 'Türkçe', value: 'tr' },
  { key: 'en', text: 'English', value: 'en' },
];

const Topbar = ({ onToggleSidebar = () => {} }) => {
  const { t, i18n } = useTranslation();
  const [themeState, themeDispatch] = useContext(ThemeContext);
  const [userState, userDispatch] = useContext(UserContext);
  useContext(StatusContext); // re-render once the logo arrives
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const lang = i18n.resolvedLanguage || 'en';
  const titleKey = getPageTitleKey(pathname);
  const logo = getLogo();

  const logout = async () => {
    await API.get('/api/user/logout');
    showSuccess(t('header.logout_success'));
    userDispatch({ type: 'logout' });
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <header className='pz-topbar'>
      <div className='left'>
        <button
          className='pz-iconbtn pz-hamburger'
          onClick={onToggleSidebar}
          aria-label={t('ui.open_menu')}
        >
          <Icon name='bars' style={{ margin: 0 }} />
        </button>
        {logo && <img className='pz-topbar-logo' src={logo} alt='' width='24' height='24' />}
        {titleKey && <h1 className='pz-page-title'>{t(titleKey)}</h1>}
      </div>
      <div className='tools'>
        <Dropdown
          className='pz-lang'
          text={lang.toUpperCase()}
          value={lang}
          options={LANGS}
          onChange={(_, { value }) => i18n.changeLanguage(value)}
        />
        <button
          className='pz-iconbtn'
          aria-label={t('ui.toggle_theme')}
          title={t('ui.toggle_theme')}
          onClick={() => themeDispatch({ type: 'toggle' })}
        >
          <Icon name={themeState.theme === 'dark' ? 'moon' : 'sun'} style={{ margin: 0 }} />
        </button>
        {userState.user ? (
          <Dropdown
            className='pz-user'
            trigger={
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className='pz-avatar'>
                  {(userState.user.username || '?').charAt(0).toUpperCase()}
                </span>
                <span className='pz-username'>{userState.user.username}</span>
              </span>
            }
            pointing='top right'
          >
            <Dropdown.Menu>
              <Dropdown.Item icon='sign out' text={t('header.logout')} onClick={logout} />
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Button size='small' primary onClick={() => navigate('/login')}>
            {t('header.login')}
          </Button>
        )}
      </div>
    </header>
  );
};

export default Topbar;
